import type { ColumnDef } from "@tanstack/react-table";
import { SimpleTable } from "@/core/components/simple-table";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";

interface RosterSkeletonRow {
  id: string;
}

const skeletonHeader = (width: string) => () => (
  <Skeleton className={cn("h-4", width)} />
);

const SKELETON_COLUMNS: ColumnDef<RosterSkeletonRow>[] = [
  {
    id: "tech",
    header: skeletonHeader("w-20"),
    enableSorting: false,
    meta: { size: "224px" },
  },
  {
    id: "role",
    header: skeletonHeader("w-16"),
    enableSorting: false,
    meta: { size: "176px" },
  },
  {
    id: "email",
    header: skeletonHeader("w-24"),
    enableSorting: false,
    meta: { size: "260px" },
  },
  {
    id: "pay-plan",
    header: skeletonHeader("w-20"),
    enableSorting: false,
    meta: { size: "240px" },
  },
  {
    id: "department",
    header: skeletonHeader("w-24"),
    enableSorting: false,
    meta: { size: "200px" },
  },
  {
    id: "reports-to",
    header: skeletonHeader("w-20"),
    enableSorting: false,
    meta: { size: "220px" },
  },
];

export const RosterTableSkeleton = ({
  loadingRowCount = 8,
}: {
  loadingRowCount?: number;
}) => (
  <Stack gap="none" fullWidth className="min-h-0 flex-1" aria-busy="true">
    <span role="status" aria-live="polite" className="sr-only">
      Loading roster table
    </span>
    <SimpleTable
      data={[]}
      columns={SKELETON_COLUMNS}
      isLoading
      loadingRowCount={loadingRowCount}
      className="h-full w-full"
      scrollContentStyle={{ minWidth: "1320px" }}
      columnPinning={{ left: ["tech"] }}
      respectColumnWidths
    />
  </Stack>
);
